export const isWegoShopcashEnabled = (siteCode: string): boolean => {
  return ['EG', 'AE'].includes(siteCode);
};
